import React from 'react';
import { BarElement, CategoryScale, Chart as ChartJS, Legend, LinearScale, Title, Tooltip } from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { blueJeans } from "../../../config/Color";
import Annotation from "chartjs-plugin-annotation";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Annotation);

const formatLabel = (label) => {
	if (!label) return "";
	const str = typeof label === "string" ? label : String(label);
	return str;
};

const wrapLabel = (label, maxCharsPerLine= 30) => {
	const text = formatLabel(label);
	if (text.length <= maxCharsPerLine) return text;

	const words = text.split(" ");
	const lines = [];
	let currentLine = "";

	words.forEach((word) => {
		const nextLine = currentLine ? `${currentLine} ${word}` : word;
		if (nextLine.length <= maxCharsPerLine) {
			currentLine = nextLine;
		} else {
			if (currentLine) lines.push(currentLine);
			currentLine = word;
		}
	});

	if (currentLine) lines.push(currentLine);
	return lines;
};

export function ChartBar({ title, legend, content, className }) {
	const fullLabels = content.map((item) => item.type ? item.type : item.control);

	const data = {
		labels: fullLabels.map((label) => wrapLabel(label)),
		datasets: [{
			label: 'Total',
			data: content.map((item) => item.quantity ? item.quantity : item.total),
			backgroundColor: blueJeans(),
		},]
	};

	const options = {
		indexAxis: 'y',
		responsive: true,
		aspectRatio: 1,
		barThickness: 30,
		borderRadius: 2,
		tickInterval: 1,
		scales: {
			x: {
				display: true,
				grid: {
					display: true,
					lineWidth: 0.3,
					color: blueJeans()
				},
				ticks: {
					stepSize: 1,
					borderWidth: 90,
					autoSkip: true,
					maxRotation: 90,
					color: blueJeans()
				}
			},
			y: {
				afterFit: (scaleInstance) => {
					scaleInstance.width = Math.max(scaleInstance.width, 150);
				},
				ticks: {
					color: blueJeans()
				},
				grid: {
					display: false
				}
			}
		},
		plugins: {
			legend: {
				display: false,
			},
			title: {
				display: false,
			},
			tooltip: {
				callbacks: {
					title: (items) => {
						const index = items[0]?.dataIndex;
						if (index != null && fullLabels[index]) {
							return fullLabels[index];
						}
						return items[0]?.label ?? "";
					},
				},
			},
		},
	};


	return (
		<div className={`${className} element-kpi element-kpi-l bars-horizontal`}>
			<div className={"element-kpi-title"}>
				<h4 className={"color-primary"}>{title}</h4>
			</div>
			<div className={"chart-bar"}>
				<Bar options={options} data={data}/>
			</div>
		</div>
	)
}

export default ChartBar;
